var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSql(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.4 33.5",
    style: {
      enableBackground: "new 0 0 26.4 33.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.7,19.8V14c0-0.1,0-0.3,0-0.4V7.4c0-3.4-5.9-5.3-11.5-5.3S1.7,4,1.7,7.4v18.7C2,29.5,8,31.4,13.6,31.4 c4.6,0,8.5-1.1,10.2-3c0.6-0.6,0.9-1.4,0.9-2.3v-5.8C24.7,20.1,24.7,20,24.7,19.8z M13.2,4c6,0,9.6,2,9.6,3.4s-3.7,3.4-9.6,3.4 s-9.6-2-9.6-3.4S7.2,4,13.2,4z M3.6,16.5c2.3,1.6,6.2,2.4,10,2.4s7.3-0.8,9.3-2.2v3.4c-0.1,0.3-0.2,0.6-0.4,0.8 c-1.1,1.2-4.3,2.4-8.9,2.4c-6,0-9.8-2-10-3.5V16.5z M22.4,14.7c-1.1,1.2-4.3,2.4-8.9,2.4c-6,0-9.8-2-10-3.5v-3.2 c2.2,1.5,6,2.3,9.6,2.3s7.4-0.8,9.6-2.3v3.5C22.8,14.2,22.6,14.5,22.4,14.7z M22.4,27.1c-1.1,1.2-4.3,2.4-8.9,2.4 c-6,0-9.8-2-10-3.5v-3.3c2.3,1.6,6.2,2.4,10,2.4s7.3-0.8,9.3-2.2v3.2C22.8,26.5,22.7,26.9,22.4,27.1L22.4,27.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSql);
export default __webpack_public_path__ + "static/media/sql.336992de04e5acafd95ce0efc1506073.svg";
export { ForwardRef as ReactComponent };